// extracted by mini-css-extract-plugin
export var questionBox = "_69-0";